<div>
  <div class="container">
    <div class="title-container">
      <p class="section-pre-header" i18n>Featured Chefs</p>
      <img class="section-left-img" src="assets/merchant-landing-page/work-together-right-section.png">
      <img class="section-right-img" src="assets/merchant-landing-page/onions.png" alt="Onions">
      <img class="section-left-dot" src="assets/merchant-landing-page/rectangle-red-icon.png"/>
      <img class="section-right-dot" src="assets/merchant-landing-page/rectangle-yellow-icon.png"/>
      <h1 i18n>Meet Your Local Culinary Stars</h1>
    </div>
    <div class="featured-chefs-desc">
      <p i18n>Dive into the stories behind the dishes with our featured chefs. From traditional family recipes to
        innovative culinary creations, experience the diversity and passion that fuel our community</p>
    </div>
  </div>

  <div class="featured-chefs-items-container" #featuredChefsItemsContainer>
    <featured-chef-item *ngFor="let merchant of merchants"
                        [chefName]="merchant.name"
                        [cuisineName]="''"
                        [chefImage]="merchant.profilePictureURL ?? '' "
                        [slugName]="merchant.slug">
    </featured-chef-item>
  </div>
  <div class="text-center mx-1">
    <button class="button-primary" routerLink="/restaurants" routerLinkActive="active" i18n>Explore All Chefs</button>
  </div>
</div>
